<a class="bottom-link" routerLink="/login/unsupported-browser" trans="browser_problem_link.text">
  (Problem with browser?)
</a>
